import type { MouseEvent } from 'react'
import { Tooltip } from 'antd'
import { FnCell, MetaLoadingCell, ShiftCell, StatusDot } from './StatusCells'
import type { CashTerminal } from './types'
import { formatPing, isUkm5, terminalLabel } from './utils'
import styles from '@/pages/CashPage.module.css'

interface Props {
  terminal: CashTerminal
  archiveTab: boolean
  onOpen: (t: CashTerminal) => void
  onCopyIp: (ip?: string) => void
}

export function CashGridCard({ terminal, archiveTab, onOpen, onCopyIp }: Props) {
  const online = terminal.status === 'online'
  const ukm5 = isUkm5(terminal.type)
  const stop = (e: MouseEvent) => e.stopPropagation()

  return (
    <article
      className={[
        styles.gridCard,
        !archiveTab && online ? styles.gridCardOnline : '',
        !archiveTab && !online ? styles.gridCardOffline : '',
        archiveTab ? styles.gridCardArchived : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={() => {
        if (!archiveTab) onOpen(terminal)
      }}
      role="presentation"
    >
      <div className={styles.gridCardHead}>
        <div className={styles.gridCardTitle}>
          <strong>{terminalLabel(terminal)}</strong>
          <span className={styles.typeChip}>{ukm5 ? 'УКМ‑5' : 'УКМ‑4'}</span>
        </div>
        {!archiveTab ? <StatusDot online={online} /> : <span className={styles.muted}>Архив</span>}
      </div>

      <div className={styles.gridCardMeta}>
        <Tooltip title="Скопировать IP">
          <button
            type="button"
            className={styles.ipBtn}
            onClick={(e) => {
              stop(e)
              onCopyIp(terminal.ip)
            }}
          >
            {terminal.ip || '—'}
          </button>
        </Tooltip>
        {!archiveTab ? (
          <span className={styles.ping}>{formatPing(terminal.ms)}</span>
        ) : (
          <span className={styles.muted}>
            {terminal.archivedAt
              ? new Date(terminal.archivedAt).toLocaleDateString('ru-RU')
              : '—'}
          </span>
        )}
      </div>

      {!archiveTab ? (
        <div className={styles.gridCardPills}>
          {terminal.kktFnPending ? (
            <>
              <MetaLoadingCell label="Смена…" />
              <MetaLoadingCell label="ФН…" />
            </>
          ) : (
            <>
              <ShiftCell label={terminal.kktStatus} />
              <FnCell label={terminal.fnStatus} />
            </>
          )}
        </div>
      ) : null}

      {terminal.comment ? <p className={styles.gridComment}>{terminal.comment}</p> : null}
    </article>
  )
}

export { copyIpToClipboard } from './copyIp'
